import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class NativeWindowService {
    nativeWidth: number = null;
   	public _nativeWidthSource = new BehaviorSubject<number>(null);
	public nativeWidth$ = this._nativeWidthSource.asObservable();

    nativeHeight: number = null;
    public _nativeHeightSource = new BehaviorSubject<number>(null);
	public nativeHeight$ = this._nativeHeightSource.asObservable();

    constructor() { }

    setNativeWidth(nativeWidth: number){
        //console.log("setNativeWidth", nativeWidth);
        this.nativeWidth = nativeWidth;
        this._nativeWidthSource.next(this.nativeWidth);
    }

    setNativeHeight(nativeHeight: number){
        //console.log("setnativeHeight", nativeHeight);
        this.nativeHeight =  nativeHeight;
        this._nativeHeightSource.next(this.nativeHeight);
    }
}
